import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import cn from 'classnames';

import './index.scss';

const styles = bemGenerator('page-header', [
  'header',
  'media',
  'content',
  'mobile',
  'title',
  'title-wrapper',
]);

const PageHeader = (
  { children, className, media, title, titleLogo, titleSubnode, label, right },
  props
) => (
  <header
    {...props}
    className={cn(
      styles.block.withModifier({ verticallyCentered: !children }),
      className
    )}
  >
    <div className={styles.media}>
      {titleLogo}
      {media}
    </div>
    <div className={styles.content}>
      {label}
      <span className={styles['title-wrapper']}>
        <h1 className={styles.title}>{title}</h1>
        {titleSubnode}
      </span>
      {children}
    </div>
    {right && <div>{right}</div>}
  </header>
);

const { node, string, element } = PropTypes;

PageHeader.propTypes = {
  children: node,
  className: string,
  media: node,
  title: string,
  titleLogo: node,
  titleSubnode: node,
  right: node,
  banner: string,
  label: element,
};

PageHeader.defaultProps = {
  titleSubnode: null,
  right: null,
  children: null,
  className: null,
  media: null,
  title: null,
  titleLogo: null,
  banner: null,
  label: null,
};

export default PageHeader;
